import AlertBar from './AlertBar'

export default AlertBar
// eslint-disable-next-line import/export
export * from './AlertBar'
